// KeraLush runtime — accordions + tabs. No framework. ~2KB.
(function () {
  function onClick(e) {
    var acc = e.target.closest && e.target.closest('[data-kl-acc]');
    if (acc) {
      var open = acc.getAttribute('data-kl-acc-open') === 'true';
      acc.setAttribute('data-kl-acc-open', open ? 'false' : 'true');
      return;
    }
    var tab = e.target.closest && e.target.closest('[data-kl-tab]');
    if (tab) {
      var idx = tab.getAttribute('data-kl-tab');
      var scope = tab.closest('section') || document;
      scope.querySelectorAll('[data-kl-tab]').forEach(function (b) {
        b.setAttribute('data-kl-tab-active', b.getAttribute('data-kl-tab') === idx ? 'true' : 'false');
      });
      scope.querySelectorAll('[data-kl-tabpanel]').forEach(function (p) {
        p.setAttribute('data-kl-tab-active', p.getAttribute('data-kl-tabpanel') === idx ? 'true' : 'false');
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { document.addEventListener('click', onClick); });
  } else {
    document.addEventListener('click', onClick);
  }
})();
